window._ = require('lodash');
window.Popper = require('@popperjs/core');
import Anime from 'animejs/lib/anime.es';
import WebFont from 'webfontloader';

window.anime = Anime;

window.$ = window.jQuery = require('jquery');
window.Tether = require('tether');
require('bootstrap');

import bsCustomFileInput  from 'bs-custom-file-input';
document.addEventListener('DOMContentLoaded', function () {
    bsCustomFileInput.init();
})

import lightbox from 'lightbox2';
window.lightbox = lightbox;

lightbox.option({
    'resizeDuration' : 200,
    'wrapAround' : true,
    'imageFadeDuration' : 200,
})

window.moment = require('moment');
moment.locale('ko');
moment.updateLocale('ko', {
    weekdays: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
    weekdaysShort: ["일", "월", "화", "수", "목", "금", "토"],
});

window.Dropzone = require('dropzone');
window.nestable = require('nestable2'); // nestable
window.feather = require('feather-icons'); // feathericon.com
window.tinymce = require('tinymce'); // tinymce
window.ClipboardJs = require('clipboard'); // clipboard
window.Sortable = require('sortablejs');

window.slick = require('slick-carousel');
window.axios = require('axios');
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept-Language'] = 'ko';
window.token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found.');
}

const apiToken = document.head.querySelector('meta[name="api-token"]');
if (apiToken) {
    window.axios.defaults.headers.common.Authorization = `Bearer ${apiToken.content}`;
}

WebFont.load({
    custom: {
        families: ['Spoqa Han Sans Neo:300,400,700'],
        urls: ['/fonts/font.css'],
        timeout: 2000
    }
});

require('eonasdan-bootstrap-datetimepicker'); // bootstrap datetime4

$.extend(true, $.fn.datetimepicker.defaults, {
    dayViewHeaderFormat: 'YYYY년 MM월',
    locale: 'ko',
    timeZone: 'Asia/Seoul',
    icons: {
        time: 'datetime-icon datetime-icon-clock',
        date: 'datetime-icon datetime-icon-calendar',
        up: 'datetime-icon datetime-icon-arrow-up',
        down: 'datetime-icon datetime-icon-arrow-down',
        previous: 'datetime-icon datetime-icon-chevron-left',
        next: 'datetime-icon datetime-icon-chevron-right',
        today: 'datetime-icon datetime-icon-check',
        clear: 'datetime-icon datetime-icon-trash',
        close: 'datetime-icon datetime-icon-circle'
    }
});

// 숫자 타입에서 쓸 수 있도록 format() 함수 추가
Number.prototype.format = function () {
    if (this === 0) return 0;

    var reg = /(^[+-]?\d+)(\d{3})/;
    var n = (this + '');

    while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');

    return n;
};

// 문자열 타입에서 쓸 수 있도록 format() 함수 추가
String.prototype.format = function () {
    let num = parseFloat(this);
    if (isNaN(num)) return '0';

    return num.format();
    // https://stove99.tistory.com/113
};

window.removeComma = (x) => {
    if (!x) {
        return '';
    }

    return x.replace(/,/g, '');
};
